import { isNil } from '@flowio/is';
import { error as requestError } from '@flowio/request';
import createOrganizationSession from './create-organization-session';
import createShopifySession from './create-shopify-session';

function createSession(options, callback) {
  switch (options.sessionType) {
    case 'shopify':
      {
        if (isNil(options.shop)) {
          requestError(options, 'options.shop is required');
          return;
        }

        createShopifySession(options.shop, callback);
        break;
      }

    case 'organization':
      {
        if (!options.organization) {
          requestError(options, 'options.organization is required');
          return;
        }

        createOrganizationSession(options.organization, callback);
        break;
      }

    default:
      requestError(options, 'options.sessionType is invalid');
  }
}

export default createSession;
//# sourceMappingURL=create-session.js.map